// extracted by mini-css-extract-plugin
export default {"timerWrapper":"Timer_timerWrapper__GmCph"};